import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import "../../../Assets/Scss/Mosttr.scss"
import { BASE_URL } from "../../../Config/axiosInstance";


function MostTrendingStore() {
  const { topRatedStores } = useSelector((state) => state.Stores);
  return (
    <div className="carousel pt-3 pb-0">
      <Container>
        {" "}
        <h5 className="Recommended" 
        style={{color:"#2b3cbb", fontSize:"1.6rem", marginBottom:"2vh", marginLeft:"5px"}}>Most Trending Stores</h5>{" "}
      </Container>

        <Container>
          <Row id="most-t-row-h3">
            {topRatedStores.slice(0, 12).map((store, index) => (
              
              <Col lg="2" className="mb-3" key={index} >
                <Link to={`/store/${store.store_details.slug}`}>
                    <img className="imgDesign"
                      src={`${BASE_URL}/${store?.store_details?.image}`}
                      alt="store"
                      style={{ objectFit: "contain" , borderColor: "#2b3cbb", margin:"0",}}
                    />
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
    </div>
  );
}

export default MostTrendingStore;
